import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
// Models
import { BusinessUsersRO } from '@models/user/user.model.ro';
import { BusinessUser } from '@models/user/user.model';
// Services
import { UserService } from '@services/user/user.service';

@Component({
	selector: 'sf-users-select',
	templateUrl: './users-select.component.html',
	styleUrls: ['./users-select.component.scss']
})
export class UsersSelectComponent implements OnChanges {
	@Input() public userId: string = null;
	@Input() public label: string = null;
	@Input() public placeholder: string = '';
	@Input() public errorTip: string = null;
	@Input() public parentId: string = null;
	@Input() public disabled: boolean = false;
	@Output() public changeUser = new EventEmitter<string>();

	public users: Array<BusinessUser> = [];
	public savedParentId: string = null;
	public usersLoading: boolean = false;

	public constructor(private userService: UserService) { }

	public ngOnChanges(): void {
		if (!this.usersLoading && this.parentId && (this.parentId != this.savedParentId || !this.users?.length)) {
			this.savedParentId = this.parentId;

			this.getUsers();
		}
	}

	private getUsers(): void {
		this.usersLoading = true;

		this.userService.getBusinessUsers(this.parentId).subscribe({
			next: (res: BusinessUsersRO): void | boolean => {
				if (!res?.result) return false;

				res.data?.sort((userA: BusinessUser, userB: BusinessUser) => {
					return userA?.fName?.toLowerCase() > userB?.fName?.toLowerCase() ? 1 : -1
				});

				this.users = res.data?.filter((user: BusinessUser) => user?.fDeleted == 0);
			}
		}).add(() => this.usersLoading = false);
	}
}